﻿import { Configuration, PopupRequest } from '@azure/msal-browser';

/**
 * Azure AD Authentication Configuration
 * MSAL (Microsoft Authentication Library) configuration for frontend
 */

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID || "44a6c43b-d852-463e-8ea5-3cf770a5375e",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID || "f66fae02-5d36-495b-bfe0-78a6ff9f8e6e"}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || "http://localhost:5173",
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI || "http://localhost:5173",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: number, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case 0:
            console.error(message);
            break;
          case 1:
            console.warn(message);
            break;
          case 2:
            console.info(message);
            break;
          case 3:
            console.debug(message);
            break;
        }
      },
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    "api://44a6c43b-d852-463e-8ea5-3cf770a5375e/access_as_user"
  ],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8081",
  scopes: ["api://44a6c43b-d852-463e-8ea5-3cf770a5375e/access_as_user"],
};

export const isAuthEnabled = true;
